import { useState } from "react";
import { useSelector } from "react-redux";

import Posts from "./PaymentHistory";
import Pagination from "../../../StyledComponents/Pagination";
import { BillingFooter, BillingFooterSpacer } from "../styles";

const PaymentHistory = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(5);

  const invoList = useSelector((state) => state.Billing.InvoList);

  const paidInvoices = invoList.filter((inv) => {
    const balance = parseFloat(inv.total_balance || inv.balance || 0);
    const billed = parseFloat(inv.total_billed || inv.total_amount || inv.amount || 0);
    return billed > 0 && balance === 0;
  });

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = paidInvoices.slice(indexOfFirstPost, indexOfLastPost);
  const howManyPages = Math.ceil(paidInvoices.length / postsPerPage);

  return (
    <>
      <Posts PaymentLists={currentPosts} />
      <BillingFooter>
        {currentPosts.length !== 0 && howManyPages > 1 ? (
          <Pagination pages={howManyPages} setCurrentPage={setCurrentPage} />
        ) : (
          <BillingFooterSpacer />
        )}
      </BillingFooter>
    </>
  );
};

export default PaymentHistory;
